import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { PlataformaCanaisDeContatoComponent } from './plataforma-canais-de-contato.component';
import { CabecalhoDireitaModule } from '../../components/cabecalho/cabecalho-direita/cabecalho-direita.module';
import { BeneficioEsquerdaModule } from '../../components/beneficio/beneficio-esquerda/beneficio-esquerda.module';
import { BeneficioDireitaModule } from '../../components/beneficio/beneficio-direita/beneficio-direita.module';
  
@NgModule({
  declarations: [
    PlataformaCanaisDeContatoComponent
  ],
  imports: [
    TranslateModule,
    CommonModule,
    CabecalhoDireitaModule,
    BeneficioEsquerdaModule,
    BeneficioDireitaModule
  ],
  exports: [
    PlataformaCanaisDeContatoComponent
  ]
})

export class PlataformaCanaisDeContatoModule { }
